import "./favorites.css";
import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useFavorites } from "../../context/FavoritesContext";
import { useCart } from "../../context/CartContext";
import { fetchWishlistProducts } from "../../api/favorites.api";

const Favorites = ({ onClose }) => {
  const navigate = useNavigate();
  const { toggleFavorite } = useFavorites();
  const { updateCart, isProductInCart } = useCart();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    fetchWishlistProducts()
      .then((data) => {
        if (!mounted) return;
        setItems(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (mounted) setItems([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="loading-wrap">
        <div className="loader" />
        <p>Loading favorites</p>
      </div>
    );
  }

  return (
    <div
      className="favorites-overlay"
      onClick={onClose}
    >
      <div
        className="favorites-popup"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="favorites-header">
          <h3>MY FAVORITES</h3>
          <span
            className="close-btn"
            onClick={onClose}
          >
            ×
          </span>
        </div>

        {/* EMPTY */}
        {items.length === 0 && (
          <div className="empty-favorites">
            <div className="empty-icon">♡</div>
            <p>Your favorites list is empty</p>
            <span>
              Start adding items you love!
            </span>
          </div>
        )}

        {/* ITEMS */}
        {items.map((item) => {
          const productId =
            item.product_id ||
            item.product?.id ||
            item.id;
          if (!productId) return null;
          const name =
            item.name || item.product?.name;
          const image =
            item.image || item.product?.image;
          const price =
            item.selling_price ||
            item.product?.selling_price;
          const category_name = item.category_name

          return (
            <div
              className="favorites-item"
              key={productId}
            >
              <img
                src={image}
                alt={name}

                onClick={() => {
                  onClose();
                  navigate(`/category/${category_name}/product/${productId}`)
                }}
              />

              <div className="item-details">
                <h4 onClick={() => {
                  onClose();
                  navigate(`/category/${category_name}/product/${productId}`)
                }}>{name}</h4>
                <span className="item-price">
                  ₹{price}
                </span>

                {isProductInCart(productId) ? (
                  <button
                    className="go-to-cart-btn"
                    onClick={() => {
                      onClose();
                      navigate("/checkout")
                    }
                    }
                  >
                    Go to Cart
                  </button>
                ) : (
                  <button
                    className="add-to-cart-small"
                    onClick={() =>
                      updateCart({
                        type: "product",
                        id: productId,
                        delta: 1,
                      })
                    }
                  >
                    Add to Cart
                  </button>
                )}
              </div>

              <button
                className="remove-favorite-btn"
                title="Remove from favorites"
                onClick={() => {
                  toggleFavorite(productId);
                  setItems((prev) =>
                    prev.filter(
                      (p) =>
                        (p.product_id ||
                          p.product?.id ||
                          p.id) !== productId
                    )
                  );
                }}
              >
                <Trash2 size={18} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Favorites;